import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * Generate a PNG data URL QR code for the given value.
 * Returns an empty string until generated (or if value is empty).
 */
export function useQrDataUrl(value: string, size = 256): string {
  const [dataUrl, setDataUrl] = useState('');

  useEffect(() => {
    let cancelled = false;
    const trimmed = value.trim();
    if (!trimmed) {
      setDataUrl('');
      return;
    }
    QRCode.toDataURL(trimmed, {
      width: size,
      margin: 1,
      errorCorrectionLevel: 'M',
      color: { dark: '#000000', light: '#ffffff' },
    })
      .then((url) => {
        if (!cancelled) setDataUrl(url);
      })
      .catch(() => {
        if (!cancelled) setDataUrl('');
      });

    return () => {
      cancelled = true;
    };
  }, [value, size]);

  return dataUrl;
}
